var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',{attrs:{"icon":"copy","is-loading":_vm.loading},on:{"click":_vm.duplicateInvoice}},[_vm._v(" "+_vm._s(_vm.$t('Invoice.duplicateInvoice'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }